<template>
  <div class="description">
    <div class="description__inner">
    <div class="left">
      <div v-if="isMobile" class="title">
        <h1 >Винная карта <br>центра Москвы</h1>
        <AppButton :type="'link'" size="m" with-icon icon-position="right" isUppercase href="collection"  @click="selectPage('collection')">
          <template #right>
            <IconDefault name="arrow-right-long" :size="'m'" is-circled></IconDefault>
          </template>
        </AppButton>
      </div>

      <p>Sminex, девелопер №1 элитных домов, и&nbsp;премиальный винный сервис SimplePrivé представляют «Винную карту центра Москвы». <br>Проект, где встретились Fine Wine и Fine Development.</p>
      <AppButton :type="'link'" size="s" with-icon icon-position="right"  text="Смотеть видео" @click="openVideo">
        <template #right>
          <IconDefault name="play" :size="'xs'" ></IconDefault>
        </template>
      </AppButton>
    </div>
    <div v-if="!isMobile" class="right">
      <AppButton :type="'link'" size="m" with-icon icon-position="right" isUppercase href="collection"  text="Подробнее" @click="selectPage('collection')">
        <template #right>
          <IconDefault name="arrow-right-long" :size="'m'" is-circled></IconDefault>
        </template>
      </AppButton>
    </div>
    </div>
  </div>
  <AppWineList v-if="!isMobile" :items="pagesStore.getWineList"></AppWineList>
  <AppWineListSlider v-if="isMobile" :items="pagesStore.getWineList"/>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useLayoutStore } from "@stores/layout";
import { usePagesStore } from "@stores/pages";
import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";
import AppWineList from "@components/AppWineList/index.vue";
import AppWineListSlider from "@components/AppWineListSlider/index.vue";


defineOptions({
  name:'AppMainPage'
})

const layoutStore = useLayoutStore();
const pagesStore = usePagesStore();
const { isMobile } = storeToRefs(layoutStore);
const { showVideo } = storeToRefs(pagesStore)

const selectPage = (code:string)=>{
  pagesStore.setPage(code)
}

const openVideo = () => {
  showVideo.value = true;
}
</script>
<style scoped lang="scss">
  .description{
    padding: var(--space-60);
    @media screen and (max-width: 769px) {
      padding: var(--space-20) var(--space-20) var(--space-05) var(--space-20);
    }
    &__inner {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      border-bottom: 1px solid var(--color-primary-ghost-30);
      padding-bottom: var(--space-30);
      @media screen and (max-width: 769px) {
        flex-direction: column;
        padding-bottom: 0;
        border-bottom: unset;
      }
      .left {
        width: 54.8rem;
        @media screen and (max-width: 769px) {
          width: auto;
          .title{
            margin-bottom: var(--space-18 );
            display: flex;
            align-items: center;
            justify-content: space-between;
            h1{
              font-size: var(--font-size-20);
              line-height: var(--font-size-24);

            }
          }

          p {
            font-size: var(--font-size-14);
            white-space: pre-line;
          }
        }
      }
    }
  }
</style>